export const isNumber = amount => !isNaN(Number.parseFloat(amount)) && isFinite(amount);

export const isNumberNegative = amount => parseFloat(amount) < 0;

export const isInteger = amount => {
  const intRegExp = RegExp(/^\d+$/);
  return intRegExp.test(amount);
};

export const isValidEmail = email => {
  const emailRegExp = RegExp(/([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})/i);
  return emailRegExp.test(email);
};

export const isEmptyObject = (object = {}) =>
  !object || (object.constructor === Object && Object.keys(object).length === 0);

export const safeParseFloat = (value, fallbackValue) => {
  const alternateValue = fallbackValue === undefined ? NaN : fallbackValue;

  return isNumber(value) ? Number.parseFloat(value) : alternateValue;
};

export const roundDownToNearestHundred = value => {
  const result = Math.floor(value / 100) * 100;

  return result === 0 ? 100 : result;
};

export const roundUpToNearestHundred = value => {
  return Math.ceil(value / 100) * 100;
};

export const roundToNearestInt = value => {
  return Math.round(value);
};

export const addCommas = value => {
  return Number(value).toLocaleString();
};

export const isValidHttpUrl = string => {
  try {
    const newUrl = new URL(string);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (err) {
    return false;
  }
};
